module.exports = __webpack_public_path__ + "img/xuebitu.9d36e7f5.jpg";